import { toast } from "react-toastify";

export const showErrorToast = (message) => {
  toast.error(message, {
    // position: "top-right",
    autoClose: 3000
  });
};